import { useParams } from 'react-router-dom'
import EditActionForm from './EditActionForm'
import { useGetActionsQuery } from './actionsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditAction = () => {
    useTitle('geshtop-Exercise: Edit Action')

    const { actionId } = useParams()
    const { action } = useGetActionsQuery("actionsList", {
        selectFromResult: ({ data }) => ({
            action: data?.entities[actionId]
        }),
    })



    if (!action) return <PulseLoader color={"#FFF"} />



    const content = <EditActionForm action={action}  />

    return content
}
export default EditAction